/** Prefix every Grid (v2) connector type carries. */
export const GRID_CONNECTOR_TYPE_PREFIX = 'ng-';

/**
 * Whether a connector type is a Grid (v2) connector.
 *
 * Grid connectors ingest through the Grid pipeline rather than the legacy
 * dispatcher, so the surfaces fed by the legacy path — the per-packet connector
 * log above all — have nothing to show for them and are hidden instead of
 * rendering an empty state that reads as a broken connector.
 */
export const isGridConnectorType = (type) => typeof type === 'string' && type.startsWith(GRID_CONNECTOR_TYPE_PREFIX);
